import axios from 'axios';

export default function getAll(query) {
  return axios.get('/api/v1/mentionables', {
    params: { query },
    cache: { ignoreCache: true },
  });
}
